import { useAtomValue } from "jotai";
import { useRecordingControl as useBaseRecordingControl } from "../../session/controls/useRecordingControl";
import { inSessionPatientInformationAtom } from "../state";
import { sessionInfoAtom } from "../../state";

export function useRecordingControl() {
  const isPrescriber = useAtomValue(sessionInfoAtom)?.provider?.isPrescriber;
  const hasAppointment = !!useAtomValue(inSessionPatientInformationAtom)
    ?.inSessionAppointmentShortId;
  return useBaseRecordingControl(hasAppointment, isPrescriber);
}
